import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SignUp from './SignUp';
import authActions from '@/redux/auth/actions';
import invitesActions from '@/redux/invites/actions';

const mapStateToProps = ({ invites }) => ({ tokenData: invites.tokenData });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      signUp: authActions.signUp,
      fetchTokenData: invitesActions.fetchTokenData,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
